import React, { useState, useEffect } from "react";
import { ReactComponent as SuccessIcon } from "../../../../../../assets/success-eligibility.svg";
import { ReactComponent as FailedIcon } from "../../../../../../assets/failed-eligibility.svg";
import { ReactComponent as HeadSetIcon } from "../../../../../../assets/fi-rr-headset.svg";
import { ReactComponent as DocumentIcon } from "../../../../../../assets/fi-rr-document.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";

const ConfirmationStatus = ({ eligibleForClaim, contactNumber }) => {
  const navigate = useNavigate();

  return (
    <div className="stepper-container">
      {eligibleForClaim ? (
        <div>
          <SuccessIcon />

          <div style={{ marginTop: "30px" }}>
            <h4 className="result-header-text" style={{ color: "#314064" }}>
              Congratulations!
            </h4>
            <h6 className="result-sub-text">
              Your claim has been successfully submitted! Our team will review
              your case, and we will update you as soon as we have news.
            </h6>
            <h6 className="result-sub-text">
              You will also receive an email notification when there is an
              update to the status of your claim.
            </h6>
            <h6 className="result-sub-text">
              You can always check the status and progress of your claim by
              logging in to your account.
            </h6>
            <h6 className="result-sub-text">
              Your Claim ID is: <strong>{contactNumber}</strong>. Please save it
              for future reference.
            </h6>
          </div>
        </div>
      ) : (
        <div className="result-wrapper">
          <FailedIcon />

          <div style={{ marginTop: "30px" }}>
            <h4 className="result-header-text" style={{ color: "#D04244" }}>
              Submission failed
            </h4>
            <h6 className="result-sub-text">
              Unfortunately, we were unable to process your claim submission.
              Please check your internet connection and try again.
            </h6>
            <div className="support-wrapper">
              <div className="customer-support-wrapper sub-text">
                <span onClick={() => navigate("/contact-us")}>
                  <HeadSetIcon />
                  Contact our support team
                </span>
              </div>

              <div className="customer-support-wrapper sub-text">
                <span onClick={() => navigate("/disclaimer")}>
                  <DocumentIcon />
                  Read more about your rights
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfirmationStatus;
